if (!customElements.get('number-counter')) {
  customElements.define(
    'number-counter',
    class NumberCounter extends HTMLElement {
      constructor() {
        super();
        this.hasAnimated = false;
        this.duration = parseInt(this.dataset.duration || 1600, 10);
      }

      connectedCallback() {
        // Split the heading's plain text into a static prefix, the first whole number found, and a static
        // suffix. Example: "150+" -> prefix: "", target: 150, suffix: "+". Formatting inside the heading
        // (bold, links, …) is not preserved once split, so this only applies to plain-text number headings.
        const text = this.textContent.trim();
        const match = text.match(/\d+/);

        if (!match) return;

        this.target = parseInt(match[0], 10);

        const prefix = text.slice(0, match.index);
        const suffix = text.slice(match.index + match[0].length);

        this.textContent = '';

        if (prefix) {
          const prefixEl = document.createElement('span');
          prefixEl.className = 'number-counter__prefix';
          prefixEl.textContent = prefix;
          this.appendChild(prefixEl);
        }

        this.valueEl = document.createElement('span');
        this.valueEl.className = 'number-counter__value';
        this.valueEl.textContent = this.formatValue(0);
        this.appendChild(this.valueEl);

        if (suffix) {
          const suffixEl = document.createElement('span');
          suffixEl.className = 'number-counter__suffix';
          suffixEl.textContent = suffix;
          this.appendChild(suffixEl);
        }

        if (window.FoxTheme && FoxTheme.config.motionReduced) {
          this.valueEl.textContent = this.formatValue(this.target);
          return;
        }

        if (window.FoxTheme && FoxTheme.Motion && typeof FoxTheme.Motion.inView === 'function') {
          FoxTheme.Motion.inView(this, this.animate.bind(this), { margin: '0px 0px -50px 0px' });
        } else {
          this.animate();
        }
      }

      formatValue(value) {
        return value.toLocaleString(document.documentElement.lang || undefined);
      }

      animate() {
        if (this.hasAnimated) return;
        this.hasAnimated = true;

        const start = performance.now();
        const to = this.target;

        const step = (now) => {
          const progress = Math.min((now - start) / this.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);

          this.valueEl.textContent = this.formatValue(progress === 1 ? to : Math.round(to * eased));

          if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
      }
    }
  );
}
